<template>
  <v-row>
    <v-col cols="12">
      <v-text-field append-icon="mdi-check"
                    @click:append="addItem(textFieldValue)"
                    :color="color"
                    @keydown.enter="addItem(textFieldValue)"
                    @keydown.esc="cancelEdit()"
                    @keydown.tab="addItem(textFieldValue)"
                    :hide-details="!limit"
                    :hint="`${$t('general.maximum')} ${limit} ${$t('general.items')}`"
                    :label="label"
                    persistent-hint
                    v-model="textFieldValue">
      </v-text-field>
    </v-col>

    <v-col cols="12">
      <CustomChip @click="editItem(index)"
                  @delete="deleteItem(index)"
                  @edit="editItem(index)"
                  :key="item"
                  :editing="indexForEdit === index"
                  v-for="(item, index) in value">
        {{ item }}
      </CustomChip>
    </v-col>
  </v-row>
</template>

<script>
import CustomChip from '@/pages/App/Conversations/components/CustomChip.vue'
export default {
  components: { CustomChip },
  data: () => ({
    indexForEdit: -1,
    textFieldValue: ''
  }),
  methods: {
    addItem (item) {
      if (this.clean) {
        item = this.cleanString(item)
      }
      if (!item) return

      if (this.value.length >= this.limit && this.indexForEdit === -1) return

      if (this.indexForEdit > -1) {
        this.value.splice(this.indexForEdit, 1)
      }

      if (this.value.findIndex(i => i === item) > -1) return

      this.value.push(item)
      this.textFieldValue = ''
      this.indexForEdit = -1
      this.value.sort()
    },
    cancelEdit () {
      if (this.indexForEdit === -1) return
      this.textFieldValue = ''
      this.indexForEdit = -1
    },
    cleanString (value) {
      let cleanString = value
      // to lowerCase
      cleanString = cleanString.toLowerCase()
      // remove dots
      cleanString = cleanString.toString().replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '') // eslint-disable-line
      // remove accent
      cleanString = cleanString.normalize('NFD')
        .replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, '$1') // eslint-disable-line
        .normalize()
      // remove spaces
      cleanString = cleanString.trim()
      return cleanString
    },
    editItem (index) {
      this.indexForEdit = index
      this.textFieldValue = this.value[index]
    },
    deleteItem (index) {
      this.value.splice(index, 1)
      this.indexForEdit = -1
      this.textFieldValue = ''
    }
  },
  props: ['color', 'clean', 'label', 'limit', 'value']
}
</script>

<style>
  .custom-chip {
    background-color: #e4ffe0;
    border: solid 1px #4f8e62;
    border-radius: 8px;
    display: inline-flex;
    margin: 2px 4px;
    padding: 8px 16px;
  }

  .custom-chip-selected {
    background-color: #fac0c8 !important;
    border: solid 1px #C92239 !important;
    transition: all .2s ease-in-out;
  }
</style>
